module.exports = __webpack_public_path__ + "img/demo1-about-ja.ab5b44c4.png";